import { useCompositeStoreOptions, useCompositeStoreProps } from "../__chunks/7KULBIZY.js";
import "../__chunks/RS7KBRGA.js";
import { useStore, useStoreProps } from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import { __spreadValues } from "../__chunks/PNRLI7OV.js";

// src/radio/radio-store.ts
import * as Core from "@ariakit/core/radio/radio-store";
function useRadioStoreOptions(props) {
  return useCompositeStoreOptions(props);
}
function useRadioStoreProps(store, props) {
  store = useCompositeStoreProps(store, props);
  useStoreProps(store, props, "value", "setValue");
  return store;
}
function useRadioStore() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const options = useRadioStoreOptions(props);
  const store = useStore(() => Core.createRadioStore(__spreadValues(__spreadValues({}, props), options)));
  return useRadioStoreProps(store, props);
}
export { useRadioStore, useRadioStoreOptions, useRadioStoreProps };